"use client";

import { useSpineSlice } from "@/components/site/motion/useSpineSlice";
import { SplitTarget } from "@/components/site/SplitTarget";
import { useContent } from "@/components/site/ContentProvider";
import { localeHref } from "@/content/index";
import styles from "./projects-cta.module.css";

export function Projects() {
  useSpineSlice((m) => m.spine!.buildCases());
  const site = useContent();
  const workHref = localeHref(site.locale, "work");

  return (
    <div className="landing_content projects_content f a-c j-c" id="projects">
      <div className="project_set full_page f a-c j-c work_mask">
        {site.projects.map((project) => {
          const href = project.marquee
            ? workHref
            : project.caseStudyId
              ? `${workHref}?case=${encodeURIComponent(project.caseStudyId)}#${project.caseStudyId}`
              : workHref;
          const label = project.marquee
            ? site.labels.viewAllProjects
            : site.labels.viewCaseStudy;

          return (
            <div className="project f f-c a-c j-c" id={project.id} key={project.id}>
              <div className="project_details f f-c a-c s-b">
                <div className="project_title">
                  <SplitTarget as="h2" className="static" text={project.title} />
                </div>
                <div className="project_meta f f-c a-c">
                  <span className="uppercase mobile _ele">{project.description}</span>
                  <div className="project_tags">
                    <div className="tags f">
                      {project.tags.map((tag) => (
                        <div className="tag _ele" key={tag}>
                          <span className="small label">{tag}</span>
                        </div>
                      ))}
                    </div>
                  </div>
                  {/* Real <a> — not jump_link; subpage route only (ADR-020). */}
                  <a href={href} className={`site_btn f a-c j-c ${styles.cta}`}>
                    <strong className="label">{label}</strong>
                  </a>
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
